import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DropdownDirectiveService implements OnDestroy {
    private active$ = new BehaviorSubject<boolean>(false);

    public activeStatusChange$ = this.active$.pipe(
        distinctUntilChanged(),
    );

    toggleActive() {
        this.active = !this.active;
    }

    get active() {
        return this.active$.getValue();
    }

    set active(status: boolean) {
        this.active$.next(status);
    }

    ngOnDestroy() {
        this.active$.complete();
    }
}
